const orients = ['vertical', 'horizontal'];
function facet (orient) {
  if (!arguments.length) return this.__attrs__.facet;
  if (orients.includes(orient)) this.__attrs__.facet = {orient: orient};
  else this.__attrs__.facet = {orient: orients[0]};
  return this;
}

export default facet;


// WEBPACK FOOTER //
// ./layouts/default/facet.js